import { useContext } from 'react';
import { DatabaseChartsDataContext } from '../contexts/DatabaseChartsDataContext';

export const useDatabaseChartsDataContext = () => {
    return useContext(DatabaseChartsDataContext);
};
